var map = {
	"./ana-carolina.png": "96ad",
	"./daniel-farias.png": "4051",
	"./daniel-moura.png": "6aae",
	"./manhattan-fomento-mercantil.png": "4c8a",
	"./rafael-mota.png": "4d69"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9ff5";